import { render, staticRenderFns } from "./OrganizationPeerGroupSettings.vue?vue&type=template&id=d241003e&scoped=true&"
import script from "./OrganizationPeerGroupSettings.vue?vue&type=script&lang=ts&"
export * from "./OrganizationPeerGroupSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d241003e",
  null
  
)

export default component.exports